// extracted by mini-css-extract-plugin
export default {"container":"components-Cart-PaymentAndRegistrationForm-styles-module__container--b3JW4","cta":"components-Cart-PaymentAndRegistrationForm-styles-module__cta--Gco7A"};